import styled from 'styled-components'

export const StyledNewsViewAll = styled.div`
  .jato-nav-bar {
    align-items: flex-start;
  }
`
